import * as React from 'react'
import Head from 'next/head'
import { AuthWrapper } from 'containers/Auth'
import MyOrders from 'pages_/MyOrders'
import { useTranslations } from 'containers/Translations/TranslationsContext'

function OrdersAndPaymentsPage() {
  const t = useTranslations()

  return (
    <>
      <Head>
        <title>{t('Web.MyOrdersAccountSettings.Title')}</title>
      </Head>

      <AuthWrapper>
        <MyOrders />
      </AuthWrapper>
    </>
  )
}

export default OrdersAndPaymentsPage
